import { utils } from "../../utils/Utils";
import { useTrackingEvent } from "../../Hooks/useAddTrackingEvent";
import { UserContext } from "../Definitions/UserContext";

// Declare a variable to hold the current handler reference
let currentpageshowHandler: ((event: PageTransitionEvent) => void) | null = null;

// Get UserID Static ID from Cookies 
function GetUserID() {
    let UserID = "VjyaDUqIaJ9ZTvKEP9kn6g==";
    let LoginDetails = utils.ReadCookie();
    let LoginUserID = LoginDetails.csEncUid;
    if (typeof LoginUserID != "undefined" && LoginUserID != null && LoginUserID != "") {
        UserID = LoginUserID;
    }
    return UserID;
};

// Function to handle history back events
function HandleHistoryBack(callback: () => void) {
    // If there's already a handler, remove it
    if (currentpageshowHandler) {
        window.removeEventListener('pageshow', currentpageshowHandler);
    }

    // Define and assign the new handler
    currentpageshowHandler = function (event: PageTransitionEvent) {
        if (event.persisted) {
            //This page was restored from the bfcache.
            callback();
        }
    };

    // Add the new handler
    window.addEventListener('pageshow', currentpageshowHandler);
}; 

// Tarking Envent hook call on PageLoad 
export function TrackingOnLoad(userContext: UserContext) {
    const [TrackEvent] = useTrackingEvent();
    let UserID = GetUserID();
    let ParentMerchantID = userContext.parentbid || "QX9p3jq6~mMP6js9ReeSqw==";
    let Reffrer = window.location.pathname.split("/").find(val => val !== "") || "";

    if (userContext.staticencbid && userContext.staticencbid !== "") {
        TrackEvent(
            ParentMerchantID,
            userContext.staticencbid,
            UserID,
            1,
            window.location.origin + "/" + Reffrer,
            "",
            () => { }
        );
        HandleHistoryBack(() => { TrackingOnLoad(userContext) });
    };

    return null; // This component only tracks, renders nothing
};

